<template>
  <div class="main">
    <!-- Logo Virteum -->
    <div class="logo-container">
      <img src="data/logo_virteum.png" alt="" class="logo-img" />
    </div>
    <!-- Start screen -->
      <div class="start-container flex-v-center" v-show="showStartscreen">
        <VirteumCard
        class="intro-card"
        :image="startscreen.image"
        :title="startscreen.title"
        :copy="startscreen.copy"
        :visible="showStartscreen"
        :showClosingIcon="false"
        :showConfirmButton="true"
        :confirmText="startscreen.confirm"
        @closing="startLoading"
        @confirmed="startLoading"
      />
      </div>

    <!-- Loading screen -->
    <div class="loading-container" v-if="showLoadingScreen">
      <div class="loading-text">{{ appProgressPercent }}%</div>
    </div>
    <!-- Instructions element -->
    <div class="instructions-container flex-v-center" v-show="showInstructions">
      <VirteumCard
      class="intro-card"
          :image="instructions.image"
          :title="instructions.title"
          :copy="instructions.copy"
          :visible="showInstructions"
          :showClosingIcon="true"
          :showConfirmButton="false"
          :confirmText="instructions.confirm"
          @closing="toggleInstructionsVisibility"
          @confirmed="toggleInstructionsVisibility"
        />
    </div>

    
    <!-- Menu element -->
    <div class="mainmenu-container" v-show="appStarted">
      <div class="mainmenu-button" @click="toggleInstructionsVisibility">
        <img
          src="./assets/icon_info_active.svg"
          alt="Button um die Anleitung auszublenden"
          v-show="!showInstructions"
        />
        <img
          src="./assets/icon_info_inactive.svg"
          alt="Button um die Anleitung einzublenden"
          v-show="showInstructions"
        />
      </div>
      <div class="mainmenu-button" @click="toggleTopVisibility">
        <img
          src="./assets/icon_top_active.svg"
          alt="Button um das Oberteil auszublenden"
          v-show="!topVisible"
        />
        <img
          src="./assets/icon_top_inactive.svg"
          alt="Button um das Oberteil einzublenden"
          v-show="topVisible"
        />
      </div>
      <div class="mainmenu-button" @click="toggleBottomVisibility">
        <img
          src="./assets/icon_bottom_active.svg"
          alt="Button um das Unterteil auszublenden"
          v-show="!bottomVisible"
        />
        <img
          src="./assets/icon_bottom_inactive.svg"
          alt="Button um das Unterteil einzublenden"
          v-show="bottomVisible"
        />
      </div>
      <div class="mainmenu-button" @click="toggleHotspotsVisibility">
        <img
          src="./assets/icon_details_active.svg"
          alt="Button um das Unterteil auszublenden"
          v-show="!hotspotsVisible"
        />
        <img
          src="./assets/icon_details_inactive.svg"
          alt="Button um das Unterteil einzublenden"
          v-show="hotspotsVisible"
        />
      </div>
    </div>
    <!-- DetailsTextElement -->
    <div class="detail-container" >
      <VirteumCard
          :image="'data/' + activeDetail.image"
          :title="activeDetail.title"
          :copy="activeDetail.copy"
          :visible="activeDetailId>0"
          :showClosingIcon="true"
          :showConfirmButton="false"
          @closing="closeDetails"
          class="detail-card"
        />
    </div>

    
    <!-- Playcanvas -->
    <canvas id="application-canvas" v-show="appStarted"></canvas>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VirteumCard from "./components/VirteumCard.vue";

export default {
  name: "App",
  components: { VirteumCard },
  data: () => {
    return {
      showStartscreen: false,
      showInstructions: false,
      appCreated: false,
      appStarted: false,
      appProgress: 0,
      // activeDetail: 0,
      topVisible: true,
      bottomVisible: true,
      hotspotsVisible: true,
    };
  },
  methods: {
    ...mapActions(["loadDetails", "setActiveDetailId"]),
    initApp(app) {
      this.app = app;
      app.on("preload:progress", (p) => (this.appProgress = p));
      app.on("start", () => (this.appStarted = true));
      app.on("detail:active:change", this.detailActiveChange, this);
    },
    detailActiveChange(newId) {
      // console.log("change id to " + newId);
      this.setActiveDetailId(newId);
      // this.app.fire("detail:active:set", newId);
    },
    toggleTopVisibility() {
      this.topVisible = !this.topVisible;
      if (!this.topVisible && !this.bottomVisible) this.bottomVisible = true;
    },
    toggleBottomVisibility() {
      this.bottomVisible = !this.bottomVisible;
      if (!this.topVisible && !this.bottomVisible) this.topVisible = true;
    },
    toggleHotspotsVisibility() {
      this.hotspotsVisible = !this.hotspotsVisible;
    },
    toggleInstructionsVisibility() {
      this.showInstructions = !this.showInstructions;
    },
    closeDetails() {
      this.setActiveDetailId(0);
    },
    startLoading() {
      this.showStartscreen = false;
      this.showInstructions = true;
      this.createPcCanvas();
    },
    createPcCanvas() {
      var script = document.querySelector("#pcstartscript");
      if (script) document.body.removeChild(script);
      script = document.createElement("script");
      script.setAttribute("id", "pcstartscript");
      var self = this;
      script.onload = function () {
        //do stuff with the script
        // console.log("script loaded");
        window.pc.script.createLoadingScreen(function (app) {
          self.initApp(app);
        });
      };
      script.src = "__start__.js";
      document.body.appendChild(script);
    },
  },
  computed: {
    ...mapGetters(["details", "activeDetail", "activeDetailId","startscreen","instructions"]),
    showLoadingScreen() {
      return !this.showStartscreen && !this.appStarted;
    },
    appProgressPercent() {
      return Math.round(this.appProgress * 100);
    },
  },
  created() {
    this.loadDetails();
    setTimeout(()=>this.showStartscreen=true,300);
    // this.createPcCanvas();
  },
  watch: {
    topVisible: function (n) {
      this.app.fire("visibility:top:set", n);
    },
    bottomVisible: function (n) {
      this.app.fire("visibility:bottom:set", n);
    },
    hotspotsVisible: function (n) {
      this.app.fire("visibility:details:set", n);
    },
    activeDetailId: function (n) {
      this.app.fire("detail:active:set", n);
    },
  },
};
</script>

<style>
:root {
  --mg-top: 7rem;
  --menu-mg-top: 7rem;
  --mg-left: 5rem;
  --img-diam: 4rem;
  --d-width: min(37.875rem, 90vw);
  --i-width: min(40rem, 90%)
  --fs-400: 16px;
  --co-light: #fff;
  --co-dark: #000;
  --co-accent: #a80000;
  --co-accent-light: #a33838;
  --pa-textbox: 3.875rem 4.5rem 3.875rem 4.5rem;
  --bo-textbox-radius: 2.8125rem;
  --btn-radius: 0rem;
  --btn-border-width: 1px;
  --btn-border-style: solid;
  --btn-padding: 0.5rem;
}
html {
  font-size: var(--fs-400);
}
body {
  font-size: var(--fs-400);
}
/* LOGO */
.logo-container {
  position: absolute;
  z-index: 101;
  top: 0.25rem;
  left: 5%;
  right: 5%;
  /* display: flex; */
  display: none;
  justify-content: center;
  align-items: center;
  user-select: none;
}
.logo-img {
  height: min(3rem, 15vh, 10vw);
}
/* START SCREEN , LOADING, INSTRUCIONS*/
  .flex-v-center{
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }
/* .start-container {
  position: absolute;
  z-index: 99;
  top: 3.5rem;
  bottom: 2.5rem;
  left: 10%;
  right: 10%;
} */
.start-container,
.instructions-container{
  position: absolute;
  z-index: 98;
  top: 3.5rem;
  bottom: 2.5rem;
  left: 10%;
  right: 10%;
}
.intro-card{
  width: var(--i-width);
}
.loading-container {
  position: absolute;
  z-index: 99;
  bottom: 0.5rem;
  left: 0.5rem;
  right: 0.5rem;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
.loading-text {
  color: var(--co-accent);
  font-size: 2rem;
  width: min(40rem, 90%);
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: calc(100vh - 25rem);
  overflow-y: auto;
}

/* MAIN MEUN */
.mainmenu-container {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  z-index: 6;
}
.mainmenu-button {
  cursor: pointer;
  user-select: none;
}
/* DETAILS  */
.detail-container {
  width: var(--d-width);
  position: absolute;
  top: var(--mg-top);
  left: var(--mg-left);
  z-index: 5;
}
.detail-card{
  max-height: calc(100vh - 7.5rem);
}

@media screen and (min-width: 769px) {
  .mainmenu-container {
    position: absolute;
    top: var(--menu-mg-top);
    left: 1rem;
  }
}
@media screen and (min-width: 501px) and (max-width: 768px){
  :root {
  --menu-mg-top: 65px;
  }
  .mainmenu-container {
    position: absolute;
    top: var(--menu-mg-top);
    left: 1rem;
  }
}
@media screen and (max-width: 500px) {
  :root {
    --mg-top: 2rem;
    --img-diam: 3rem;
    --d-width: 90vw;
    --fs-400: 13px;
  }
  .mainmenu-container {
    flex-flow: row;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    position: absolute;
    bottom: 0.5rem;
    left: 0.5rem;
    right: 0.5rem;
    z-index: 2;
  }
  .logo-img {
    display: none;
  }
  .detail-container {
    width: 90%;
    position: absolute;
    top: var(--mg-top);
    left: 5%;
    right: 5%;
    z-index: 5;
  }
  
}

/* Transition */
.detailsview-enter-active,
.detailsview-leave-active {
  transition: all 0.25s ease;
}
.detailsview-enter-active .image-container,
.detailsview-leave-active .image-container {
  transition: all 0.5s ease;
  transition-delay: 0.15s;
}
.detailsview-enter-from,
.detailsview-leave-to {
  opacity: 0;
  transform: translateY(1rem);
}
.detailsview-enter-from .image-container,
.detailsview-leave-to .image-container {
  opacity: 0;
  transform: translateY(1rem);
}
</style>
